"use strict";

import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.App = window.App || {};

window.App.realtime = {
	init: function () {
		var config = window.App.realtimeConfig || {};

		if (!config.userId) {
			return;
		}

		this._startReconciliation(config.enabled && config.key ? 60000 : 10000);

		if (!config.enabled || !config.key || window.Echo) {
			return;
		}

		window.Pusher = Pusher;
		window.Echo = new Echo({
			broadcaster: "pusher",
			key: config.key,
			cluster: config.cluster,
			forceTLS: true,
			authEndpoint: "/broadcasting/auth",
			auth: {
				headers: {
					"X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')?.content || "",
				},
			},
		});

		window.Echo.private("App.Models.User." + config.userId)
			.notification(function () {
				window.App.notifications?.received?.();
			});

		window.Echo.private("activity-tracker")
			.listen(".activity.created", function () {
				window.App.activityTrackerDrawer?.received?.();
			});
	},

	_startReconciliation: function (interval) {
		window.setInterval(function () {
			if (document.hidden) {
				return;
			}

			window.App.notifications?.refreshCount?.();
			window.App.activityTrackerDrawer?.poll?.();
		}, interval);
	},
};

jQuery(function () {
	window.App.realtime.init();
});
